import React, { useState } from "react";
import abuse_styles from './Abuse.module.css';
import styled from 'styled-components';
import agree_img from '../resources/agree.svg';
import disagree_img from '../resources/disagree.svg';
import strongly_disagree_img from '../resources/completely_disagree.svg';
import strongly_agree_img from '../resources/strongly_agree.svg';

import grey_agree_img from '../resources/grey_agree.svg';
import grey_disagree_img from '../resources/grey_disagree.svg';
import grey_strongly_disagree_img from '../resources/grey_strong_disagree.svg';
import grey_strongly_agree_img from '../resources/grey_strongly_agree.svg';
import QuestionBox from "../components/QuestionBox";

import Select, { components } from 'react-select';


const FlexBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props} >
        <span style={{ fontSize: '11px', lineHeight: '4px', marginLeft: '-6px'}}>&#9660;</span>
      </components.DropdownIndicator>
    );
  };

  export const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: '5px', // Adjust border radius as needed
      borderColor: '#93B3FC', // Border color of the select box
      minHeight: '20px',
        height: '30px',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
        width: '250px'
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#93B3FC',
      height: '5px',
      width: '5px',
       // Color of the dropdown indicator triangle
    }),
  };

const Abuse = (props) => {
    const questions = [
        "Have you ever had sex (vaginal, anal, or oral) with someone in exchange for money, drugs, or shelter?",
        "In the past 3 months, how often has anyone you have been intimate with (sexually or not) abused you emotionally, physically, or sexually?",
        "I could refuse if someone wanted to have sex without a condom or a dental dam.",
        "I would be able to say no if a friend offered me a drink of alcohol.",
        "I would be able to refuse if a friend offered me drugs, including marijuana."
        ]
    const [answers, setAnswers] = useState([0, 0, 0, 0, 0]);
    // console.log(answers)

    React.useEffect(() => {
        const filteredAnswers = answers.filter(value => value === 0);
        if (filteredAnswers.length == 0) {
            let data = {
                SEXFORRESOURCES: answers[0],
                ANYABUSE_3M: answers[1],
                CNTRL_REFUSECNDM: answers[2],
                CNTRL_ALC: answers[3],
                CNTRL_DRG: answers[4]
            }
            props.setAbuseInfoData(data);
            props.setNextButton(true);
            props.onAllAnswered(false);
        } else {
            props.setNextButton(false);
        }
    }, [answers]);

    const handleAnswerChange = (index, value) => {
        const newAnswers = [...answers];
        newAnswers[index] = parseInt(value);
        setAnswers(newAnswers);
    }

    const options_1 = [
        { value: 1, label: "No, never had sex in exchange for money, drugs, or shelter"}, 
        { value: 2, label: "Yes, more than 3 months ago"},
        { value: 3, label: "Yes, within the past 3 months"}
    ];

    const options = [
        { value: 1, label: 'Never' },
        { value: 2, label: 'Rarely' },
        { value: 3, label: 'Sometimes' },
        { value: 4, label: 'Often' },
        { value: 5, label: 'Very Often' }
    ];

    return (<>
        {/* <PageLayout> */}
            <div className={abuse_styles.container}>
            {/* <h2 className={abuse_styles.mainTitle}>Abuse</h2> */}
            <FlexBox style={{color: (props.showUnanswered && (answers[0] == 0)) ? 'red' : 'black'}}>
                    <div className={abuse_styles.firstQuestionDiv}>
                         <QuestionBox question={questions[0]} index={1}></QuestionBox>
                    </div>
                    <div className={abuse_styles.selectDiv}>
                        <Select
                                options={options_1}
                                components={{ DropdownIndicator }}
                                styles={customStyles}
                                placeholder="Select an option"
                                onChange={(op) => handleAnswerChange(0, op.value)}
                                isSearchable={false}
                                />
                    </div>
                </FlexBox>
                <FlexBox style={{color: (props.showUnanswered && (answers[1] == 0)) ? 'red' : 'black'}}>
                    <div className={abuse_styles.firstQuestionDiv}>
                         <QuestionBox question={questions[1]} index={2}></QuestionBox>
                    </div>
                    <div className={abuse_styles.selectDiv}>
                        <Select
                                options={options}
                                components={{ DropdownIndicator }}
                                styles={customStyles}
                                placeholder="Select an option"
                                onChange={(op) => handleAnswerChange(1, op.value)}
                                isSearchable={false}
                                />
                    </div>
                </FlexBox>
                {questions.slice(2).map((question, index) => (
  <FlexBox
    key={index}
    style={{
      marginBottom: '0px',
      color: props.showUnanswered && answers[index + 2] === 0 ? 'red' : 'black',
    }}
  >
    <div className={abuse_styles.questionDiv}>
      <QuestionBox question={question} index={index + 3} />
    </div>
    <div className={abuse_styles.selectDiv}>
      <Select
        options={[
          { value: 1, label: 'Strongly Agree' },
          { value: 2, label: 'Agree' },
          { value: 3, label: 'Disagree' },
          { value: 4, label: 'Strongly Disagree' }
        ]}
        components={{ DropdownIndicator }}
        styles={customStyles}
        placeholder="Select an option"
        onChange={(op) => handleAnswerChange(index + 2, op.value)}
        isSearchable={false}
      />
    </div>
  </FlexBox>
))}

            </div>
            {/* <div className={abuse_styles.button}>
                <NextButton></NextButton>
            </div>
        </PageLayout> */}
    </>
    );
}

export default Abuse;